/**
 * Configure and register global directives
 */
import type { App } from 'vue';
import { setupPermissionDirective } from './permission';
import { setupHasDirective } from './tenantPermission';
import { setupLoadingDirective } from './loading';
import {setupDebounceDirective,setupThrottleDirective} from './debounceAndThrottle'
import {setupDragDirective} from './drag'
export function setupGlobDirectives(app: App) {
  setupPermissionDirective(app);
  setupHasDirective(app);
  setupLoadingDirective(app);
  setupDebounceDirective(app);
  setupThrottleDirective(app);
  setupDragDirective(app);
}
